import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";

import { CancellationProtectionTermsList } from "./CancellationProtectionTermsList";

interface TermsTabContentProps {
  workerId: string;
}

export function TermsTabContent(props: TermsTabContentProps) {
  const { workerId } = props;

  useLogEffect(APP_V2_USER_EVENTS.CANCELLATION_PROTECTION_TERMS_TAB_VIEWED, {
    workerId,
  });

  return (
    <Stack sx={{ paddingX: 5, paddingTop: 9, paddingBottom: 11 }}>
      <CancellationProtectionTermsList variant="overview" />
    </Stack>
  );
}
